import React from 'react';
import { StyleSheet, View } from 'react-native';
import { ToastPayload } from './types';
import { ToastItem } from './ToastItem';

type Props = {
  toasts: ToastPayload[];
  onRemove: (id: string) => void;
};

export const ToastContainer: React.FC<Props> = ({ toasts, onRemove }) => {
  return (
    <View pointerEvents="box-none" style={styles.container}>
      {toasts.map((toast, index) => (
        <ToastItem
          key={toast.id}
          toast={toast}
          index={index}
          onHide={() => onRemove(toast.id)}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 70,
    right: 24,
    zIndex: 10000,

    alignItems: 'flex-end',
    pointerEvents: 'box-none',
  },
});
